export default class BundleProviderParameter {
	constructor( 
        public BundleId: string,
        public ProviderId: string
    ) { }
}